import { Map } from 'immutable';
import { createContext } from 'react';

import { EmailVerificationActions } from '../../actions/email-verification/EmailVerificationActions';
import {
    API_STATUSES,
    EmailVerificationStatuses,
    SignUpModes,
} from '../../constants';
import { IApiError } from '../../errors';
import { IField, ImmutableMap } from '../../typings';

interface IEVStatusApiResponse {
    bu: string;
    eid: string;
    email: string;
    status: EmailVerificationStatuses;
}

export interface IEmailVerificationState {
    mode: SignUpModes;
    evStatus: IEVStatusApiResponse;
    evStatusAPISubmit: {
        status: API_STATUSES;
        error: IApiError;
    };
    emailField: IField<string>;
    changeEmailSubmit: {
        status: API_STATUSES;
        error: IApiError;
        showError: boolean;
    };
}

export type ImmutableEmailVerificationState =
    ImmutableMap<IEmailVerificationState>;

interface IEmailVerificationContextValue {
    state: ImmutableEmailVerificationState;
    dispatch: React.Dispatch<EmailVerificationActions>;
}

export const initialState: IEmailVerificationState = {
    mode: SignUpModes.STANDARD,
    evStatus: {
        bu: '',
        eid: '',
        email: '',
        status: EmailVerificationStatuses.PENDING,
    },
    evStatusAPISubmit: {
        status: API_STATUSES.IDLE,
        error: null,
    },
    emailField: {
        value: '',
        valid: false,
        error: '',
        showError: false,
    },
    changeEmailSubmit: {
        status: API_STATUSES.IDLE,
        error: null,
        showError: false,
    },
};

export const INITIAL_EMAIL_VERIFICATION_STATE = Map(initialState);

const defaultValue: IEmailVerificationContextValue = {
    state: INITIAL_EMAIL_VERIFICATION_STATE,
    dispatch: () => null,
};

const EmailVerificationContext =
    createContext<IEmailVerificationContextValue>(defaultValue);

export default EmailVerificationContext;
